'use client';

import { SkipLinks, SkipLinksItem } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';

import { SKIP_LINK_IDS } from './constants';

type Props = {
  title?: string;
  url?: string;
  links?: { title: string; url: string }[];
};

const Links = ({ title, url, links }: Props) => {
  const { t } = useTranslation('webshop');

  return (
    <SkipLinks>
      {links ? (
        links.map((link, key) => (
          <SkipLinksItem key={key} href={link.url}>
            {t(link.title)}
          </SkipLinksItem>
        ))
      ) : (
        <SkipLinksItem href={url ?? `#${SKIP_LINK_IDS.MAIN_CONTENT}`}>
          {t(title ?? 'skipLinks.general.mainContent')}
        </SkipLinksItem>
      )}
    </SkipLinks>
  );
};

export default Links;
